/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FC, LabelHTMLAttributes, ReactNode } from "react";
import { cva } from "cva";
import classNames from "classnames";
import { Text } from "..";

type Props = {
  children: ReactNode
  className?: string
  isPreview?: boolean
  required?: boolean
  locked?: boolean
  error?: boolean
} & LabelHTMLAttributes<HTMLLabelElement>
const LabelStyles = cva("font-bold leading-6 break-words whitespace-pre-wrap", {
  variants: {
    state: {
      default: [
        "-text--component-colors-field-default-label-text",
        "disabled:-text--component-colors-field-disabled-label-text",
        "hover:-text--component-colors-field-hover-label-text",
        "selection:-text--component-colors-field-selected-label-text"
      ],
      error: "-text--component-colors-field-error-label-text",
      locked: "-text--component-colors-field-locked-label-text",
    }
  },
  defaultVariants: {
    state: "default"
  }
})

const Label: FC<Props> = ({
  className,
  children,
  locked,
  error,
  isPreview,
  ...props
}) => (
  isPreview ?
    <Text className="-text--theme-colors-text-subtitle-brand text-sm break-words whitespace-pre-wrap">
      {children}{props.required && <span>*</span>}
    </Text>
    :
    <label className={classNames(LabelStyles({ state: (error && "error") || (locked && "locked") || "default" }), className)} {...props}>{children}{props.required && <span className="-text--component-colors-field-default-label-mandatory">*</span>}</label>

);

export default Label;
